import customHandlers from '../helpers/custom-handlers';
import { OPTIONS_SYMBOL } from '../constants/symbols';

const subscribe = (hookName, callback, options = {}) => {
  if (typeof callback !== 'function') throw new Error('callback is not a function');
  const hookHandler = callback;

  hookHandler[OPTIONS_SYMBOL] = options;

  if (customHandlers.has(hookName)) {
    const handlers = customHandlers.get(hookName);
    customHandlers.set(hookName, [...handlers, hookHandler]);
    return;
  }
  customHandlers.set(hookName, [hookHandler]);
};

export default subscribe;
